import Markdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

const defaultComponents: Components = {
  table: ({ children }) => (
    <div className="my-2 overflow-x-auto">
      <table className="w-full border-collapse text-sm">{children}</table>
    </div>
  ),
  th: ({ children }) => (
    <th className="border border-gray-200 bg-gray-50 px-2 py-1 text-left font-medium">{children}</th>
  ),
  td: ({ children }) => <td className="border border-gray-200 px-2 py-1 text-left">{children}</td>,
};

type MarkdownContentProps = {
  children: string;
  components?: Components;
};

/** Renders GitHub-flavored markdown (tables, strikethrough, task lists, etc.). */
export function MarkdownContent({ children, components }: MarkdownContentProps) {
  return (
    <Markdown remarkPlugins={[remarkGfm]} components={{ ...defaultComponents, ...components }}>
      {children}
    </Markdown>
  );
}
